//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getConnectedInstagramBusinessAccount = createSelector(
  (state: ICuralateStore) => state.facebookInstagramSettings,
  (fbIgSettings) => fbIgSettings.connectedInstagramAccount,
);

export const getConnectedInstagramBusinessAccountId = createSelector(
  getConnectedInstagramBusinessAccount,
  (connectedAccount) => connectedAccount?.businessAccountId,
);
